import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import Anchor from '../../../../../components/link/Anchor';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import Tag from '../../../../../components/tag/Tag/Tag';
import { TAG_STATUS_TEXT } from '../../../../../constants/service/app/tagConstants';
import { TAG_HISTORY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import OpenPreviewTagDetail from '../../../../../containers/app/common/OpenPreviewTagDetail';
import { setDash, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  추천 상품 후기에 연결된 상품 후기 아이템 리스트 컬럼
 */
export const columns = (data) => {
  const { isFilter, filterOption, sortOption, onFilter } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      sorter: isFilter,
      sortOrder: sortOption['url'],
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'태그 ID'} filterValue={filterOption.tagId} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'상품 번호 검색'}
          option={filterOption.tagId}
          confirm={confirm}
          onFilter={(tagId) => onFilter({ tagId })}
        />
      ),
      render: (value) => (
        <Anchor
          text={value}
          isUnderLine
          color="primary"
          href={setDetailPageUrl(TAG_HISTORY_URL_PATH, value)}
          target="_blank"
        />
      ),
    },
    {
      title: <TableColumnTitle title={'태그명'} filterValue={filterOption.tagName} />,
      dataIndex: 'name',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'상품 번호 검색'}
          option={filterOption.tagName}
          confirm={confirm}
          onFilter={(tagName) => onFilter({ tagName })}
        />
      ),
      render: (value, record) => <OpenPreviewTagDetail text={value} tagId={record.id} />,
    },
    {
      title: <TableColumnTitle title={'태그 상태'} />,
      dataIndex: 'status',
      render: (value) => TAG_STATUS_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'태그 그룹'} />,
      dataIndex: 'tagGroupList',
      render: (value) =>
        value && value.length
          ? value.map((tagGroupName, index) => <Tag key={index} text={tagGroupName} isAddHash={false} />)
          : setDash(value),
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      sorter: isFilter,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value),
    },
  ];
};
